import { useTranslation } from "react-i18next";
import { usePageTitle } from "@/hooks/usePageTitle";
import { withBranding } from "@/utils/helper";
import { Clock } from "lucide-react";

const fakeApps = [
  {
    name: "Attendance Pro",
    category: "Time & Attendance",
    rating: "4.8",
    price: "Free",
  },
  {
    name: "Payslip Generator",
    category: "Payroll",
    rating: "4.6",
    price: "AED 99/mo",
  },
  {
    name: "Leave Tracker",
    category: "Leave Management",
    rating: "4.5",
    price: "Free",
  },
  {
    name: "Performance Hub",
    category: "Performance",
    rating: "4.7",
    price: "AED 149/mo",
  },
  {
    name: "Document Vault",
    category: "Documents",
    rating: "4.9",
    price: "Free",
  },
  {
    name: "Expense Manager",
    category: "Finance",
    rating: "4.4",
    price: "AED 79/mo",
  },
];

export const CompanyMarketplace = () => {
  const { t } = useTranslation("company");
  usePageTitle(withBranding(t("marketplace.page_title")));

  return (
    <div className="relative flex flex-col gap-4 min-h-[60vh]">
      {/* Fake background content */}
      <div className="blur-xs pointer-events-none select-none" aria-hidden>
        {/* Search bar */}
        <div className="flex gap-3 mb-2">
          <div className="flex-1 h-10 rounded-md border border-border bg-white" />
          <div className="h-10 w-28 rounded-md bg-primary opacity-40" />
        </div>

        {/* Category chips */}
        <div className="flex gap-2 mb-4">
          {[
            t("marketplace.category_all"),
            t("marketplace.category_payroll"),
            t("marketplace.category_hr_tools"),
            t("marketplace.category_finance"),
            t("marketplace.category_analytics"),
          ].map(
            (c, i) => (
              <span
                key={i}
                className={`text-xs px-3 py-1 rounded-full border ${i === 0 ? "bg-primary text-white border-primary" : "border-border text-gray-600 bg-white"}`}
              >
                {c}
              </span>
            ),
          )}
        </div>

        {/* App cards */}
        <div className="grid grid-cols-3 gap-4">
          {fakeApps.map((app, i) => (
            <div
              key={i}
              className="rounded-md border border-border bg-white p-4 flex flex-col gap-2"
            >
              <div className="w-10 h-10 rounded-lg bg-primary/20 flex items-center justify-center">
                <div className="w-5 h-5 rounded bg-primary/40" />
              </div>
              <p className="font-semibold text-sm text-gray-800">{app.name}</p>
              <p className="text-xs text-gray-500">{app.category}</p>
              <div className="flex items-center justify-between mt-1">
                <span className="text-xs text-yellow-600">★ {app.rating}</span>
                <span className="text-xs font-medium text-primary">
                  {app.price}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Coming Soon overlay */}
      <div className="absolute inset-0 flex flex-col items-center justify-center z-10">
        <div className="flex flex-col items-center gap-3 bg-white/80 backdrop-blur-xs rounded-xl border border-border px-10 py-8 shadow-lg">
          <div className="w-14 h-14 rounded-full bg-primary/10 flex items-center justify-center">
            <Clock className="w-7 h-7 text-primary" />
          </div>
          <h2 className="text-xl font-bold text-gray-800">
            {t("marketplace.coming_soon")}
          </h2>
          <p className="text-sm text-gray-500 text-center max-w-xs">
            {t("marketplace.coming_soon_description")}
          </p>
        </div>
      </div>
    </div>
  );
};

export default CompanyMarketplace;
